import * as React from 'react';
import './TrialPhasePage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ITrialPhaseReduxFormState, initialTrialPhaseState } from "../../../reducers/reactReduxForms/trialPhase";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as TrialPhaseActions from '../../../actions/trialPhases';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { TrialLookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';
interface ITrialPhasePageParams {
  trialPhaseId: number;
}
interface ITrialPhasePageProps {
  form: Dtos.TrialPhase & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: ITrialPhaseReduxFormState;
  location: Location;
  trialPhaseId: number;
  match: match<ITrialPhasePageParams>;
  history: History;

  // From state
  trialPhase: Dtos.TrialPhase;
  lookups: Dtos.Lookup[];
  loadingTrialPhase: boolean;
  loadTrialPhaseSuccess: boolean;
  loadTrialPhaseFailure: boolean;
  savingTrialPhase: boolean;
  saveTrialPhaseSuccess: boolean;
  saveTrialPhaseFailure: boolean;
  creatingTrialPhase: boolean;
  createTrialPhaseSuccess: boolean;
  createTrialPhaseFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
}
interface ITrialPhasePageActions {
  clearTrialPhase: TrialPhaseActions.ITrialPhaseClearActionCreator;
  loadTrialPhase: TrialPhaseActions.ITrialPhaseLoadByIdActionCreator;
  saveTrialPhase: TrialPhaseActions.ITrialPhaseSaveActionCreator;
  createTrialPhase: TrialPhaseActions.ITrialPhaseCreateActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type TrialPhasePageProps = ITrialPhasePageProps & ITrialPhasePageActions;
const reduxFormName: string = "reduxForms.trialPhase";
class TrialPhasePage extends React.PureComponent<TrialPhasePageProps, any> {
  constructor(props: TrialPhasePageProps) {
    super(props);
    this.clearTrialPhase = this.clearTrialPhase.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
  }
  componentDidMount() {
    const {
      loadTrialPhase,
      trialPhaseId,
      createTrialPhase
    } = this.props;
    if (trialPhaseId) {
      loadTrialPhase(trialPhaseId);
    } else if (!trialPhaseId) {
      createTrialPhase();
    }
  }
  componentWillReceiveProps(nextProps: TrialPhasePageProps) {}
  componentDidUpdate(prevProps: TrialPhasePageProps, prevState) {
    const {
      trialPhaseId,
      trialPhase,
      form,
      navigate,
      loadTrialPhase,
      loadingTrialPhase,
      loadTrialPhaseSuccess,
      createTrialPhase,
      creatingTrialPhase,
      createTrialPhaseSuccess,
      savingTrialPhase,
      saveTrialPhaseSuccess,
      validationFailures
    } = this.props;
    if (trialPhaseId && prevProps.trialPhaseId != trialPhaseId) {
      loadTrialPhase(trialPhaseId);
    } else if (!trialPhaseId && prevProps.trialPhaseId) {
      createTrialPhase();
    }
    if (!loadingTrialPhase && prevProps.loadingTrialPhase) {
      if (loadTrialPhaseSuccess) {
        this.loadForm();
      }
    }
    if (!savingTrialPhase && prevProps.savingTrialPhase) {
      if (saveTrialPhaseSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/settings/trial/trialphases");
        } else if (!form.saveAndReturn && trialPhaseId && trialPhaseId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !trialPhaseId && trialPhase && trialPhase.id > 0) {
          navigate("/settings/trial/trialphases/" + trialPhase.id);
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingTrialPhase && prevProps.creatingTrialPhase) {
      if (createTrialPhaseSuccess) {
        this.loadForm();
      }
    }
  }
  componentWillUpdate(nextProps: TrialPhasePageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearTrialPhase();
    loadForm(reduxFormName, initialTrialPhaseState);
    resetForm(reduxFormName);
  }
  clearTrialPhase() {
    this.props.clearTrialPhase();
  }
  showTrialPhase(): boolean {
    const {
      loadingTrialPhase,
      loadTrialPhaseSuccess
    } = this.props;
    if (!loadingTrialPhase && loadTrialPhaseSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrialPhase
    } = this.props;
    return <TrialLookupsLayout loading={loadingTrialPhase} permission={Dtos.Permission.TrialPhasesView} data-sentry-element="TrialLookupsLayout" data-sentry-component="TrialPhasePage" data-sentry-source-file="TrialPhasePage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingTrialPhase,
      permissions
    } = this.props;
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialPhasesUpdate, Dtos.Permission.TrialPhasesCreate);
    const formDisabled: boolean = !hasPermission || savingTrialPhase || formState && formState.formStatus == Dtos.FormStatus.Disabled;
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      value: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      rank: {
        type: RegistrationComponent.RegistrationControl,
        inputType: NumberFormInput,
        inputDisabled: formDisabled
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " "
      }
    };
    return <div>
            <h1>Trial Phase</h1>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                {renderFormControls(form, "trialPhase", formComponents, lookups, validationFailures, formProperties, changeForm)}
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>

        </div>;
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
            </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.TrialPhase) {
    const {
      saveTrialPhase
    } = this.props;
    if (data) {
      let changes: Dtos.TrialPhase = ({} as Dtos.TrialPhase);
      saveTrialPhase(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.TrialPhase) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      navigate
    } = this.props;
    navigate("/settings/trial/trialphases");
  }
  loadForm() {
    const {
      loadForm,
      trialPhase
    } = this.props;
    let extraData: Dtos.TrialPhase = ({} as Dtos.TrialPhase);
    loadForm(reduxFormName, Object.assign({
      ...trialPhase
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialPhasePageProps): ITrialPhasePageProps => {
  let trialPhase: Dtos.TrialPhase | undefined = !(state.trialPhases.formData instanceof Array) ? state.trialPhases.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    trialPhaseId: ownProps.match && ownProps.match.params.trialPhaseId && ownProps.match.params.trialPhaseId.toString() != "create" ? ownProps.match.params.trialPhaseId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    trialPhase: trialPhase!,
    loadingTrialPhase: state.trialPhases.loadState && state.trialPhases.loadState.status == RequestState.Pending,
    loadTrialPhaseSuccess: state.trialPhases.loadState && state.trialPhases.loadState.status == RequestState.Success,
    loadTrialPhaseFailure: state.trialPhases.loadState && state.trialPhases.loadState.status == RequestState.Failure,
    savingTrialPhase: state.trialPhases.saveState && state.trialPhases.saveState.status == RequestState.Pending,
    saveTrialPhaseSuccess: state.trialPhases.saveState && state.trialPhases.saveState.status == RequestState.Success,
    saveTrialPhaseFailure: state.trialPhases.saveState && state.trialPhases.saveState.status == RequestState.Failure,
    creatingTrialPhase: state.trialPhases.createState && state.trialPhases.createState.status == RequestState.Pending,
    createTrialPhaseSuccess: state.trialPhases.createState && state.trialPhases.createState.status == RequestState.Success,
    createTrialPhaseFailure: state.trialPhases.createState && state.trialPhases.createState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    lookups: [],
    form: state.reduxForms.trialPhase,
    formState: state.trialPhases.formState,
    formProperties: state.trialPhases.formProperties,
    reduxFormState: state.reduxForms.formState.trialPhase,
    validationFailures: trialPhase ? state.trialPhases.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): ITrialPhasePageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadTrialPhase: bindActionCreators(TrialPhaseActions.LoadTrialPhaseById, dispatch),
    clearTrialPhase: bindActionCreators(TrialPhaseActions.Clear, dispatch),
    saveTrialPhase: bindActionCreators(TrialPhaseActions.SaveTrialPhase, dispatch),
    createTrialPhase: bindActionCreators(TrialPhaseActions.CreateTrialPhase, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialPhasePage);